export default function CTAButton({
  text = 'Get My Cash Offer',
  size = 'md',
  variant = 'primary'
}: {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary';
}) {
  const funnel_url = 'https://www.quickclosehomeoffer.com/home/';

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-10 py-4 text-lg'
  };

  const variantClasses = {
    primary: 'bg-blue-900 text-white hover:bg-blue-950',
    secondary: 'bg-white text-blue-900 border-2 border-blue-900 hover:bg-blue-50'
  };

  return (
    <a
      href={funnel_url}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-block rounded-lg transition-all hover:shadow-lg font-semibold ${sizeClasses[size]} ${variantClasses[variant]}`}
    >
      {text}
    </a>
  );
}
